import { type FC } from "react";
import { AppParagraph } from "@/shared/Components";
import { ImportantIcon } from "@/common/NotesTable/Components/ImportantIcon";
import styles from "../styles.module.scss";

interface Props {
  title: string;
  description: string;
  isDescriptions?: boolean;
  important: boolean;
}

export const Body: FC<Props> = ({ title, description, isDescriptions = true, important }) => {
  return (
    <>
      <div className={styles["body-title"]}>
        {title && <ImportantIcon important={important} />}
        <AppParagraph size="lg" weight="semibold" lineHeight="lg" className={styles.commitment}>
          {title}
        </AppParagraph>
      </div>
      {isDescriptions && (
        <AppParagraph size="md" lineHeight="xl" ellipsis={{ rows: 2 }} className={styles.note}>
          {description}
        </AppParagraph>
      )}
    </>
  );
};
